import { setupConstants } from "../_constants";
import { setupService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const setupActions = {
  getDetail,
  incrementStep,
  decrementStep,
  submitSetup
};

function getDetail(user) {
  return dispatch => {
    dispatch(request());

    setupService.getDetail(user).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: setupConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: setupConstants.DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: setupConstants.DETAIL_FAILURE, error };
  }
}

function incrementStep() {
  return dispatch => {
    dispatch(increment());
  };

  function increment() {
    return { type: setupConstants.INCREMENT_STEP };
  }
}

function decrementStep() {
  return dispatch => {
    dispatch(decrement());
  };

  function decrement() {
    return { type: setupConstants.DECREMENT_STEP };
  }
}

function submitSetup(user, values) {
  return dispatch => {
    dispatch(request());

    setupService.submitSetup(user, values).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: setupConstants.SUBMIT_REQUEST };
  }
  function success(detail) {
    return { type: setupConstants.SUBMIT_SUCCESS, detail };
  }
  function failure(error) {
    return { type: setupConstants.SUBMIT_FAILURE, error };
  }
}
